import { Injector, runInInjectionContext } from '@angular/core';
import { doc, docData, Firestore } from '@angular/fire/firestore';
import { CollectionNames, OtherCollections } from '@vmspdb/definitions';
import { Observable, startWith } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

export function withSearchSync<T>(
  collection: CollectionNames,
  injector: Injector,
) {
  const realFb = injector.get(Firestore);
  return (source: Observable<T>) =>
    source.pipe(
      switchMap((data) => {
        return runInInjectionContext(injector, () =>
          docData(doc(realFb, OtherCollections.Search, collection)).pipe(
            startWith(null),
            map(() => data),
          ),
        );
      }),
    );
}
